/**
* @file 线路管理
* */
<template>
  <div id="czLine">
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      addText="创建线路"
      @addFn="addFn"
    >
    <template slot="search-bottom">
      <div class="blueInfo">*线路报价适用于下单时为业务员提供参考报价</div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="150px">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-dropdown @command="handleCommand($event, row)">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="del">删除线路</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'"
          >{{ row.created | filterTime }}
        </template>
        <template v-else-if="item.prop === 'daytimeFee'">
          <span>日间¥{{row.daytimeFee}}、夜间¥{{row.nighttimeFee}}</span>
        </template>
        <template v-else>
          <span>{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "czLine",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/line",
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "startStationName",
            name: "出发地",
            value: "",
          },
          {
            type: "input",
            field: "endStationName",
            name: "目的地",
            value: "",
          },
        ],
      },
      // 表头
      columns: [
        { prop: "labelName", label: "分类标签" },
        { prop: "startStationName", label: "出发地" },
        { prop: "endStationName", label: "目的地" },
        { prop: "daytimeFee", label: "线路价格" },
      ],
    };
  },
  created() {},
  methods: {
    handleCommand(command, row) {
      switch (command) {
        case "del":
        this.$confirm("确定要删除该线路吗？线路删除后，该线路将无法下单", "删除线路", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete(`/api/v1/manage/airport/line`, { id: row.id })
            .then(({ code }) => {
              if (code === 1) {
                this.$message.success("删除成功");
                this.$refs.customTable.listFn();
              }
            });
        })
        .catch(() => {});
          break;
        default:
          break;
      }
    },
    // 新增
    addFn() {
      this.$router.push({ path: "/czLineEdit" });
    },
    // 编辑
    edit(row) {
      this.$router.push({
        path: "/czLineEdit",
        query: {
          id: row.id,
          name: row.name,
          type: row.type,
        },
      });
    },
  },
};
</script>

<style lang="less">
#czLine {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
